module.exports = __webpack_public_path__ + "img/success.5882ccbe.png";